var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./navigation_tabs.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2528e465\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./navigation_tabs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./pipelines/components/navigation_tabs.vue
// module id = ./pipelines/components/navigation_tabs.vue
// module chunks = pipelines